import { Component, Inject, OnInit } from '@angular/core';
import { AssignmentResource } from '@apaq/orgkit-js';
import { Pdf } from '../../../common/pdf';
import { container } from 'tsyringe';
import { DialogRef } from '../../dialog/dialog-ref';
import { DATA, DIALOG } from '../../dialog/dialog.service';
import log from 'loglevel';

export interface Data {
  assignmentIds: string[];
}

@Component({
  selector: 'app-download-invoices-dialog',
  templateUrl: './download-invoices-dialog.component.html',
  styleUrls: ['./download-invoices-dialog.component.scss']
})
export class DownloadInvoicesDialogComponent implements OnInit {

  loading = true;

  constructor(@Inject(DIALOG) private dialog: DialogRef, @Inject(DATA) private data: Data,
  private assignmentResource: AssignmentResource) {
    log.debug('DownloadInvoicesDialogComponent initialized with: ', data);
  }

  ngOnInit(): void {
    this.startDownload();
  }

  async startDownload() {
    const promises: Promise<Blob>[] = [];
    this.data.assignmentIds.forEach(id => promises.push(this.assignmentResource.getInvoice(id)));

    const pdfs = await Promise.all(promises);
    const mergedPdf = await Pdf.merge(pdfs);
    let objectUrl = URL.createObjectURL(mergedPdf);
    let a = document.createElement("a");
    a.href = objectUrl;
    a.download = $localize`invoices.pdf`;
    a.click();
    window.URL.revokeObjectURL(objectUrl);

    this.loading = false;
    setTimeout(() => this.close(), 2000);
  }

  close() {
    this.dialog.close();
  }

}
